import { useApplication } from "../../stores/hooks/useApplication";
import { useAuth } from "../../stores/hooks/useAuth";

export const useCmsLink = (): string => {
  const { cmsBaseUrl } = useApplication();
  const [{ tokenId }] = useAuth();

  return `${cmsBaseUrl}/authentication/sso/retailSite.php?tokenId=${tokenId}`;
};
